import { TripPayload } from 'store/trips/trips.types'

export type TripBuilderSelectionMode = 'tractor' | 'trailer' | 'order' | null

export const getTripOrderEventIds = (tripTasks: TripPayload[]): number[] =>
  tripTasks
    .filter(
      (task) =>
        task.orderEventId != null &&
        (task.type === 'PICKUP' ||
          task.type === 'DELIVERY' ||
          task.type === 'HOOK_TRAILER' ||
          task.type === 'DROP_TRAILER')
    )
    .map((task) => task.orderEventId as number)
